(() => {
  function start(root) {
    if(root.dataset.couponReady) return;
    root.dataset.couponReady='true';
    const page=root.dataset.mode==='page', cards=[...root.querySelectorAll('[data-coupon-item]')];
    const category=root.querySelector('[data-coupon-category]'), brand=root.querySelector('[data-coupon-brand]');
    const min=root.querySelector('[data-coupon-min]'), max=root.querySelector('[data-coupon-max]');
    const buttons=[...root.querySelectorAll('[data-coupon-offer]')];
    let state=new URL(location.href).searchParams, spotlightSignature='';
    const parse=v=>{try{return JSON.parse(v||'{}')}catch{return {}}};
    if(min)min.value=state.get('filter.v.price.gte')||'';
    if(max)max.value=state.get('filter.v.price.lte')||'';
    function refresh(){
      const registry=parse(document.getElementById('bizedeals-partnerboost-registry')?.dataset.offers);
      const active=cards.filter(card=>{
        if(typeof eligibleOffer!=='function')return false;
        const offer=eligibleOffer(registry,{asin:card.dataset.asin,path:card.dataset.path});
        return offer && offer.test!==true && offer.type==='code' && card.querySelector('[data-snapshot]');
      });
      const selectedOffers=buttons.filter(b=>state.get('filter.p.m.bizedeals.place_'+b.dataset.couponOffer)==='1');
      const department=state.get('department');
      const selectedCategory=page?(state.get('filter.p.product_type')||''):(category?.value||'');
      const selectedBrand=page?(state.get('filter.p.vendor')||''):(brand?.value||'');
      function matches(card,omit){
        const flags=parse(card.dataset.couponFlags),tags=parse(card.dataset.couponTags),price=Number(card.dataset.couponPrice);
        return (!department||tags.includes?.(department)) &&
          (omit==='category'||!selectedCategory||card.dataset.category===selectedCategory) &&
          (omit==='brand'||!selectedBrand||card.dataset.brand===selectedBrand) &&
          (!min?.value||(Number.isFinite(price)&&price>=Number(min.value))) &&
          (!max?.value||(Number.isFinite(price)&&price<=Number(max.value))) &&
          selectedOffers.every(b=>b.dataset.couponOffer==='edeals'?card.dataset.couponEdeal==='true':flags[b.dataset.couponOffer]===true);
      }
      for(const [select,key,selected] of [[category,'category',selectedCategory],[brand,'brand',selectedBrand]]){
        if(!select)continue;
        const counts=new Map();active.filter(c=>matches(c,key)).forEach(c=>{const v=c.dataset[key];if(v)counts.set(v,(counts.get(v)||0)+1)});
        const values=[...counts.keys()].sort();
        const signature=JSON.stringify([[...counts],selected]);
        if(select.dataset.values!==signature){
          while(select.options.length>1)select.remove(1);
          values.forEach(v=>select.add(new Option(v+' ('+counts.get(v)+')',v)));
          if(selected&&!values.includes(selected))select.add(new Option(selected+' (0)',selected));
          select.value=selected;select.dataset.values=signature;
        }
      }
      buttons.forEach(b=>{const on=selectedOffers.includes(b);b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',String(on));b.querySelector('span').textContent=on?'−':'+'});
      root.querySelectorAll('[data-coupon-department]').forEach(a=>{
        if(a.dataset.couponDepartment===(department||''))a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');
      });
      const visible=[];
      cards.forEach(card=>{
        const shown=active.includes(card)&&matches(card);
        card.hidden=!shown;if(shown)visible.push(card);
      });
      if(!page)root.hidden=active.length===0;
      const filters=root.querySelector('[data-coupon-filters]');if(filters)filters.hidden=false;
      const empty=root.querySelector('[data-coupon-empty]');if(empty)empty.hidden=active.length!==0;
      const noMatch=root.querySelector('[data-coupon-no-match]');if(noMatch)noMatch.hidden=active.length===0||visible.length>0;
      const count=root.querySelector('[data-coupon-count]');if(count)count.textContent=visible.length+(visible.length===1?' matching offer':' matching offers');
      const departmentLabel=root.querySelector('[data-coupon-department-label]');
      if(departmentLabel)departmentLabel.textContent=root.querySelector('[data-coupon-department][aria-current]')?.textContent || 'All departments';
      const context=root.querySelector('[data-coupon-context]');
      if(context)context.textContent=[root.querySelector('[data-coupon-department][aria-current]')?.textContent,...selectedOffers.map(b=>b.textContent.replace(/[+−]/g,'').trim()),brand?.value,category?.value].filter(Boolean).join(' · ');
      const spotlight=root.querySelector('[data-coupon-spotlight]');
      const picks=visible.slice(0,2),signature=picks.map(c=>c.dataset.path+':'+c.textContent+':'+(Date.parse(c.dataset.couponExpires)>Date.now())).join('|');
      if(spotlight&&signature!==spotlightSignature){
        spotlightSignature=signature;spotlight.replaceChildren();
        picks.forEach(card=>{
          const source=card.querySelector('bz-affiliate-card');
          if(source){
            const clone=document.createElement('article');clone.className='bz-product-card bed-coupon-feature';
            if(source.dataset.conditionalPrice)clone.dataset.conditionalPrice=source.dataset.conditionalPrice;
            for(const selector of ['.bz-product-card__image','.bz-product-card__title','.bz-product-card__conditional','.bz-product-card__offer','.bz-product-card__pending','.bz-product-card__footnote']){
              const node=source.querySelector(selector);if(node)clone.append(node.cloneNode(true));
            }
            clone.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
            spotlight.append(clone);
          }
        });
      }
      if(spotlight)spotlight.hidden=picks.length===0;
      const heroEmpty=root.querySelector('[data-coupon-hero-empty]');if(heroEmpty)heroEmpty.hidden=picks.length>0;
      root.querySelector('.bed-spotlight')?.classList.toggle('bed-banner-empty',picks.length===0);
      const chips=root.querySelector('[data-coupon-active]');
      const chipEntries=[['department',root.querySelector('[data-coupon-department][aria-current]')?.textContent],...selectedOffers.map(b=>['filter.p.m.bizedeals.place_'+b.dataset.couponOffer,b.textContent.replace(/[+−]/g,'').trim()]),['filter.p.vendor',selectedBrand],['filter.p.product_type',selectedCategory],['filter.v.price.gte',min?.value?'Min $'+min.value:''],['filter.v.price.lte',max?.value?'Max $'+max.value:'']].filter(([key,label])=>state.has(key)&&label);
      const chipSignature=JSON.stringify(chipEntries);
      if(chips&&chips.dataset.signature!==chipSignature){
        chips.replaceChildren();chipEntries.forEach(([key,label])=>{const button=document.createElement('button');button.type='button';button.className='bed-filter';button.dataset.couponRemove=key;button.textContent=label+' ×';button.setAttribute('aria-label','Remove '+label);chips.append(button)});chips.dataset.signature=chipSignature;
      }
    }
    function save(){const url=new URL(location.href);url.search=state.toString();if(url.href!==location.href)history.pushState(null,'',url);refresh();document.dispatchEvent(new Event('bizedeals:filters-changed'))}
    root.addEventListener('input',event=>{
      if(!page||!event.target.matches('[data-coupon-min],[data-coupon-max]'))return;
      for(const [el,key] of [[min,'filter.v.price.gte'],[max,'filter.v.price.lte']]){if(el?.value)state.set(key,el.value);else state.delete(key)}
      save();
    });
    root.addEventListener('change',()=>{
      if(page)for(const [el,key] of [[category,'filter.p.product_type'],[brand,'filter.p.vendor'],[min,'filter.v.price.gte'],[max,'filter.v.price.lte']]){if(el?.value)state.set(key,el.value);else state.delete(key)}
      if(page)save();else refresh();
    });
    root.addEventListener('click',event=>{
      const dept=event.target.closest('[data-coupon-department]'),offer=event.target.closest('[data-coupon-offer]');
      if(dept){event.preventDefault();if(dept.dataset.couponDepartment)state.set('department',dept.dataset.couponDepartment);else state.delete('department')}
      if(offer){const key='filter.p.m.bizedeals.place_'+offer.dataset.couponOffer;if(state.has(key))state.delete(key);else state.set(key,'1')}
      if(event.target.closest('[data-coupon-reset]')){for(const key of [...state.keys()])if(key==='department'||key.startsWith('filter.'))state.delete(key);if(min)min.value='';if(max)max.value='';}
      const remove=event.target.closest('[data-coupon-remove]');if(remove){state.delete(remove.dataset.couponRemove);if(min)min.value=state.get('filter.v.price.gte')||'';if(max)max.value=state.get('filter.v.price.lte')||'';}
      if(event.target.closest('[data-coupon-clear-mode]')){
        const url=new URL(state.has('filter.p.m.bizedeals.place_edeals')?'/collections/e-deals':'/collections/all',location.origin);
        if(state.get('department'))url.pathname+='/'+state.get('department');
        state.forEach((v,k)=>{if(k!=='department'&&k!=='filter.p.m.bizedeals.place_edeals')url.searchParams.set(k,v)});
        location.assign(url.href);return;
      }
      if(dept||offer||remove||event.target.closest('[data-coupon-reset]'))save();
    });
    window.addEventListener('popstate',()=>{state=new URL(location.href).searchParams;if(min)min.value=state.get('filter.v.price.gte')||'';if(max)max.value=state.get('filter.v.price.lte')||'';refresh();document.dispatchEvent(new Event('bizedeals:filters-changed'))});
    async function loadRemaining(){
      if(typeof eligibleOffer!=='function')return;
      const registry=parse(document.getElementById('bizedeals-partnerboost-registry')?.dataset.offers);
      const grid=root.querySelector('[data-coupon-grid]');
      if(!grid||!Array.isArray(registry.offers))return;
      const seen=new Set(cards.map(c=>c.dataset.path));
      const pending=registry.offers.filter(o=>{
        if(!/^\/products\/[a-z0-9][a-z0-9-]*$/.test(o.productPath||'')||seen.has(o.productPath))return false;
        const verified=eligibleOffer(registry,{asin:o.asin,path:o.productPath});
        if(!verified||verified.test===true||verified.type!=='code')return false;
        seen.add(o.productPath);return true;
      });
      if(!pending.length)return;
      const status=document.createElement('p');status.setAttribute('role','status');
      status.textContent='Loading more verified offers…';grid.before(status);
      let cursor=0,failed=0;
      async function consume(){
        while(cursor<pending.length&&root.isConnected){
          const offer=pending[cursor++];
          try{
            const url=new URL(offer.productPath,location.origin);url.searchParams.set('view','coupon-card');
            const preview=new URL(location.href).searchParams.get('preview_theme_id');
            if(preview)url.searchParams.set('preview_theme_id',preview);
            const response=await fetch(url,{credentials:'same-origin',signal:AbortSignal.timeout(15000)});
            if(!response.ok)throw Error('unavailable');
            const doc=new DOMParser().parseFromString(await response.text(),'text/html');
            const card=doc.querySelector('[data-coupon-item]');
            if(!card||card.dataset.path!==offer.productPath||card.dataset.asin!==offer.asin||!card.querySelector('[data-snapshot]'))throw Error('identity');
            card.querySelectorAll('script,iframe,object,embed').forEach(n=>n.remove());
            for(const el of [card,...card.querySelectorAll('*')])for(const a of [...el.attributes])if(/^on/i.test(a.name))el.removeAttribute(a.name);
            card.hidden=true;grid.append(card);cards.push(card);refresh();
          }catch{failed++;}
        }
      }
      await Promise.all(Array.from({length:Math.min(3,pending.length)},consume));
      if(failed){
        status.textContent='Some offers could not be loaded. ';
        const retry=document.createElement('button');retry.type='button';retry.textContent='Retry';
        retry.addEventListener('click',()=>{status.remove();loadRemaining()},{once:true});status.append(retry);
      }else status.remove();
    }

    document.addEventListener('visibilitychange',refresh);refresh();
    if(page)loadRemaining();
    const timer=setInterval(()=>{if(!root.isConnected)clearInterval(timer);else refresh()},1000);
  }
  document.querySelectorAll('[data-coupon-section]').forEach(start);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-coupon-section]').forEach(start));
})();


